var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlogger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5167 7.67498H15.6083C15.4667 7.67498 15.325 7.5333 15.325 7.39163C15.325 4.39997 12.8917 1.8833 10 1.8833H7.20001C4.26668 1.8833 1.875 4.26663 1.875 7.2083V12.8166C1.875 15.75 4.25835 18.1416 7.20001 18.1416H12.8083C15.7417 18.1416 18.1333 15.7583 18.1333 12.8166V9.29163C18.1333 8.39163 17.425 7.68331 16.525 7.68331L16.5167 7.67498ZM16.875 12.8083C16.875 15.05 15.05 16.8833 12.8 16.8833H7.19167C4.95 16.8833 3.11666 15.0583 3.11666 12.8083V7.19997C3.11666 4.9583 4.94167 3.12497 7.19167 3.12497H9.99166C12.2 3.12497 14.0667 5.07497 14.0667 7.38331C14.0667 8.21664 14.7667 8.91664 15.6 8.91664H16.5083C16.725 8.91664 16.8667 9.05831 16.8667 9.27498V12.8L16.875 12.8083ZM6.21666 7.42497C6.21666 6.93331 6.63332 6.51664 7.12499 6.51664H10.4917C10.9833 6.51664 11.4 6.93331 11.4 7.42497C11.4 7.91664 10.9833 8.3333 10.4917 8.3333H7.12499C6.63332 8.3333 6.21666 7.91664 6.21666 7.42497ZM13.7167 12.9166C13.7167 13.4083 13.3 13.825 12.8083 13.825H7.13333C6.64166 13.825 6.225 13.4083 6.225 12.9166C6.225 12.425 6.64166 12.0083 7.13333 12.0083H12.8083C13.3 12.0083 13.7167 12.425 13.7167 12.9166Z",
    fill: "#B1B5C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogger);
export default __webpack_public_path__ + "static/media/blogger.1dc135c3956660a106c888cb36c11c5a.svg";
export { ForwardRef as ReactComponent };